/**
 * @prettier
 */
import { WatchGroup } from "@acng/frontend-relativity";
import { AttributeLink, AttributeSetup, NodeUpgrade } from "@acng/frontend-stargazer";

import { size } from "@acng/frontend-bounty/std/array.js";
import { guard } from "@acng/frontend-rubicon";
import { cdn } from "acng/core/service/backend.js";
import { inject } from "acng/core/service/ng.js";
import { Actor } from "acng/layout/context/list.js";
import { STYLE_EMPTY, swapClass } from "acng/layout/service/style.js";
import { STYLE_INIT } from "acng/layout/style/flags.js";
import { get as getMovie } from "../../moviePool/service/cache.js";
import { ctxAmateur } from "../context/amateur.js";
import { FEED_DATA } from "../model/feed.js";
import { removeHidden } from "../service/feed.js";
import { weblogEntry } from "../service/weblog.js";
import { getLocale } from '../../locale/model/locale.js';


let DEBUG = false;
// DEBUG: DEBUG = true;
export const FEED_LIST = 'feed-list';

AttributeSetup(FEED_LIST, (name) => {
  const watch = WatchGroup(`[${name}]`, ctxAmateur);
  const provideList = Actor();
  const limit = 64;

  AttributeLink(name, (element, value) => {
    watch(element, (element, [amateur]) => {
      let isEmpty = false;

      /**
       * @param {number} offset
       */
      const more = async (offset) => {
        if (!amateur || isEmpty || offset % limit) {
          if (DEBUG) console.debug('No more items to fetch or invalid offset.');
          return [];
        }

        const params = new URLSearchParams({
          offset: `${offset}`,
          limit: `${limit}`,
          type: value || 'all'
        });
        const data = (await cdn(`amateur-profile/feed/${amateur.id}?${params}`));
        ASSERT: guard(data, FEED_DATA, 'cdn response with amateur feed list');
        if (DEBUG) console.log("🚀 ~ feed-list.js:47 ~ more ~ response:", data)
        isEmpty = swapClass(element, STYLE_EMPTY, !offset && !size(data));
        swapClass(element, STYLE_INIT, false);

        removeHidden(data);

        return data;
      };
      swapClass(element, STYLE_INIT, true);
      provideList(element, more, async (item) => {
        let feedItem;

        if (item.type === 'Movie') {
          const movie = await getMovie(item.id);
          feedItem = {
            title: movie.title,
            content: movie._description,
            published: new Date(movie.published).toLocaleDateString(getLocale()),
            image: movie.getImageUrl()
          }
        } else if (item.type === 'Picture') {
          const PictureSet = inject('PictureSet');
          const pictureSet = (await PictureSet.get(item.id));
          feedItem = {
            title: pictureSet.title,
            content: pictureSet._description,
            published: new Date(pictureSet.published).toLocaleDateString(getLocale()),
            image: pictureSet.getImageUrl()
          }
        } else if (item.type === 'Weblog') {
          const entry = await weblogEntry(item.id);
          feedItem = entry;
        }
        if (!feedItem) {
          if (DEBUG) console.warn("Unsupported feed item:", item);
          throw item;
        }
        return (element, engine) => {
          NodeUpgrade(engine, { feedItem });
          return (element) => {
            //todo maybe add a click action
          };
        }
      });
    });
  });
});
